if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.menuBody = document.getElementById('menu-mobile-body');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');
      const wrapper = document.getElementById('wrapper');

      if (this.menu && wrapper) {
        document.querySelectorAll('.mobile-menu-drawer').forEach((menu) => {
          if (menu !== this.menu) {
            menu.remove();
          }
        });
        this.menu.classList.add('jkl-header-section');
        this.menu.classList.add('jkl-teleported');
        wrapper.appendChild(this.menu);
      }

      document.addEventListener('panel:open', (event) => {
        if (event.detail.panel === this.menu) {
          this.toggle.classList.add('active');
          this.toggle.setAttribute('open', '');
          this.setHeaderBottom();
        }
      });
      document.addEventListener('panel:closed', (event) => {
        if (event.detail.panel === this.menu) {
          this.toggle.classList.remove('active');
          this.toggle.removeAttribute('open');
        }
      });

      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        e.preventDefault();
        if (OverlayManager.isOpen(this.menu)) {
          OverlayManager.close(this.menu);
        } else {
          OverlayManager.open(this.menu);
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });
      this.menu.querySelector('.mobile-menu-close')?.addEventListener('click', () => {
        OverlayManager.close(this.menu);
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });
      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderBottom.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        
        if(document.querySelector('.jkl-announcement-bar-section')) {

          let offset = parseInt(document.querySelector('.jkl-announcement-bar-section').getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
          document.querySelector('.jkl-announcement-bar-section').classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
          this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
          this.closest('.jkl-header-section').classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
        } else {
          let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
          this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
          this.closest('.jkl-header-section').classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
        }
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }

    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    setHeaderBottom() {
      let b = this.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--header-bottom', Math.max(0, b) + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');

      this.menu.scrollTop = 0;
      this.menuBody.scrollTop = 0;
      document.querySelectorAll('.mobile-menu .sub-menu').forEach(submenu => {
        submenu.scrollTop = 0;
      });

      setTimeout(() => {
         document.querySelector('.mobile-menu-drawer .thb-mobile-menu-body').classList.add('menu-opened');
        // detailsElement.classList.add('menu-opening');
        // parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      // detailsElement.classList.remove('menu-opening');
      console.log('no open menus');
     
      this.closeAnimation(detailsElement);
      setTimeout(() => {
        console.log(document.querySelectorAll('.mobile-menu-drawer .link-container[open]').length);
        if(document.querySelectorAll('.mobile-menu-drawer .link-container[open]').length == 0) {
          
          document.querySelector('.mobile-menu-drawer .thb-mobile-menu-body').classList.remove('menu-opened');
        }
      }, 500);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const toggle = e.target.closest('.thb-full-menu--toggle');
        if (toggle) toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') !== 'true');
      });
      const openToggles = () => [...this.querySelectorAll('.thb-full-menu--toggle[aria-expanded="true"]')];
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const toggle = openToggles().filter((t) => t.parentElement.contains(document.activeElement)).pop();
        if (!toggle) return;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      });
      this.addEventListener('focusout', (e) => {
        openToggles().forEach((t) => {
          if (!t.parentElement.contains(e.relatedTarget)) t.setAttribute('aria-expanded', 'false');
        });
      });
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
      this.initMegaMenuColumns();

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    /**
     * Column hover state must stay scoped to one .mega-menu-columns.
     * A document-wide querySelector was removing .active from another top-level mega menu.
     */
    // initMegaMenuColumns() {
    //   this.querySelectorAll('.mega-menu-columns .mega-menu-columns__item').forEach((item) => {
    //     item.addEventListener('mouseenter', () => {
    //       const columns = item.closest('.mega-menu-columns');
    //       if (!columns) {
    //         return;
    //       }
    //       columns.querySelectorAll('.mega-menu-columns__item.active').forEach((el) => {
    //         el.classList.remove('active');
    //       });
    //       item.classList.add('active');
    //     });
    //   });
    // }
    initMegaMenuColumns() {
      this.querySelectorAll('.mega-menu-columns .mega-menu-columns__item').forEach((item) => {
        const activateItem = () => {
          const columns = item.closest('.mega-menu-columns');
          if (!columns) {
            return;
          }

          columns.querySelectorAll('.mega-menu-columns__item.active').forEach((el) => {
            el.classList.remove('active');
          });

          item.classList.add('active');
        };

        // Mouse
        item.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') {
            activateItem();
          }
        });

        // Touch
        item.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse') {
            activateItem();
          }
        });

        // Tastiera e screen reader
        item.addEventListener('focusin', activateItem);
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}